import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nombreMoneda'
})
export class NombreMonedaPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let nombreMoneda: string;
    if(value == 'PEN') nombreMoneda = 'SOLES'
    if(value == 'USD') nombreMoneda = 'DOLARES AMERICANOS'
    return nombreMoneda;
  }

}
